import Env from '../env'

const slice = Array.prototype.slice

// 比较版本号大小，支持用法
// (">=2.4.4"),("2.4.5>=2.4.4"),("2.4.5", ">=", "2.4.4"),(">=", "2.4.4")
function compareVersion (v1, comp, v2) {
    let matches
    let args = slice.call(arguments, 0)
    let result = null
    switch (args.length) {
        case 1:
            matches = /\s*([\d.]*)\s*([>=<]+)\s*([\d.]+)\s*/.exec(v1)
            if (matches) {
                console.log('appVersion:', Env.appVersion)
                result = compareVersion(matches[1] || Env.appVersion, matches[2], matches[3])
            }
            break
        case 2:
            v2 = comp
            comp = v1
            v1 = Env.appVersion
            result = compareVersion(v1, comp, v2)
            break
        case 3:
            v1 = parseVersion(v1) + ''
            v2 = parseVersion(v2) + ''
            if (comp.match(/[<=>]+/)) {
                result = (0, eval)(v1 + comp + v2)
            }
            break
    }
    return result
}

// 将形如13.1.22.1的版本号转换为13012201的数字，用于比较
function parseVersion (version) {
    let ret = []
    let num
    version = version || ''
    version = version.split('.')
    version.length = 4

    for (let i = 0; i < version.length; i++) {
        num = version[i] * 1
        if (num) {
            ret.push(num >= 10 ? num : '0' + num)
        } else {
            ret.push('00')
        }
    }

    return parseInt(ret.join(''), 10)
}

/**
 * 指定时间内执行函数，该函数只能被执行一次
 * @param {*} fn 待执行函数
 * @param {*} time 指定时间
 * @param {*} defaultVal 默认回调值
 * @param {*} context 执行上下文
 */
function onceIn (fn, time, defaultVal = {}, context) {
    let called = false
    setTimeout(() => {
        if (!called) {
            called = true
            fn.apply(context || this, [defaultVal])
        }
    }, time)
    return function () {
        if (!called) {
            called = true
            fn.apply(context || this, arguments)
        }
    }
}

function registerJsHandler (callbackName = '', callback) {
    callbackName = callbackName + new Date().getTime()

    if (Env.isIOSApp) {
        if (window.DidiJSBridge) {
            window.DidiJSBridge.registerHandler(callbackName, callback)
        } else {
            document.addEventListener('DidiJSBridgeReady', function () {
                window.DidiJSBridge.registerHandler(callbackName, callback)
            })
        }
    } else if (Env.isAndroidApp) {
        window[callbackName] = callback
    }

    return callbackName
}

export {
    compareVersion,
    parseVersion,
    registerJsHandler,
    onceIn
}
